<div *ngIf="text" [class]="'tag ' + size">{{ text }}</div>
